import { IS_TOGGLED } from 'ACTIONS';

export const setIsToggled = (id, state) => dispatch => dispatch({
    type: IS_TOGGLED,
    id,
    state
});
